var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41959 3.20546L3.00173 0.620391C3.03363 0.654495 3.06393 0.690304 3.09264 0.726113C3.06233 0.690304 3.03203 0.654495 3.00013 0.620391C2.6668 0.262301 2.2282 0.0849609 1.7912 0.0849609C1.3542 0.0849609 0.915605 0.262301 0.580676 0.620391C-0.0875852 1.33487 -0.0859903 2.49269 0.580676 3.20717L1.7912 4.4997L0.580676 5.79394C-0.0859903 6.50671 -0.0859903 7.66454 0.580676 8.38072C0.915605 8.7371 1.3542 8.91444 1.7912 8.91444C2.2282 8.91444 2.6668 8.7371 3.00173 8.38072L5.41959 5.79394C6.08785 5.07947 6.08785 3.92164 5.41959 3.20546Z",
    fill: "#6A35FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.94577179854210601919ad85ebdafba4.svg";
export { ForwardRef as ReactComponent };